import { Separator as ShadcnSeparator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'

type SeparatorProps = React.ComponentProps<typeof ShadcnSeparator>

/**
 * Separator wrapper that fixes vertical orientation height issue after base-ui migration.
 * The original shadcn component uses self-stretch which doesn't work well in flex containers.
 */
function Separator({ className, orientation, ...props }: SeparatorProps) {
  return (
    <ShadcnSeparator
      orientation={orientation}
      className={cn(orientation === 'vertical' && 'h-4 self-auto!', className)}
      {...props}
    />
  )
}

export { Separator }
